export const EDIT_ITEM_EXISTING = "EDIT_ITEM_EXISTING";
export const EDIT_ITEM_NEW = "EDIT_ITEM_NEW";
export const EDIT_ITEM_UPDATE = "EDIT_ITEM_UPDATE";
export const EDIT_ITEM_APPLY = "EDIT_ITEM_APPLY";
export const EDIT_ITEM_STOP = "EDIT_ITEM_STOP";
export const EDIT_ITEM_RESET = "EDIT_ITEM_RESET";

export const COMMIT_DATA = "COMMIT_DATA";
